// THIAGOLAYOUT

import { FC } from 'react';
import { Button, Spinner, OverlayTrigger, Popover } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClosedCaptioning } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  isLoading?: boolean;
  disabled?: boolean;
  titlePopOver?: string;
  onClick: (event: any) => Promise<void>;
}

const styleButtonCaption = { marginLeft: 10 }

const ButtonCaption: FC<IProps> = ({
  isLoading,
  disabled,
  titlePopOver,
  onClick
}) => {
  return (

    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={
        <Popover>
          <Popover.Body>
          {titlePopOver}
          </Popover.Body>
        </Popover>
      }>
        <Button
         style={styleButtonCaption}
         disabled={disabled || isLoading || false}
         type="button"      
         onClick={(e) => onClick(e)}>
         {isLoading &&
           <Spinner
             as="span"
             animation="border"
             size="sm"
             role="status"
             aria-hidden="true"
           />
         }
         &nbsp;<FontAwesomeIcon icon={faClosedCaptioning} className='me-1' />      
       </Button>
    </OverlayTrigger>
  );
}

export default ButtonCaption;